import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide010TemplateCoachReflection() {
  return <KbGuidePage slug="guide-010-template-coach-reflection" />;
}

(Guide010TemplateCoachReflection as unknown as { path: string }).path = "/automations/template-coach-reflection";
